var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.626,
    height: 13.294,
    viewBox: "0 0 17.626 13.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "envelope",
    d: "M15.7,59.882H1.624A1.626,1.626,0,0,0,0,61.506v9.746a1.626,1.626,0,0,0,1.624,1.624H15.7a1.626,1.626,0,0,0,1.624-1.624V61.506A1.626,1.626,0,0,0,15.7,59.882Zm0,1.083a.538.538,0,0,1,.208.042l-7.246,6.28-7.246-6.28a.539.539,0,0,1,.208-.042Zm0,10.829H1.624a.542.542,0,0,1-.541-.541v-9.1l7.225,6.262a.542.542,0,0,0,.71,0l7.225-6.262v9.1A.542.542,0,0,1,15.7,71.793Z",
    transform: "translate(0.15 -59.732)",
    fill: "#bcbcbc",
    stroke: "#bcbcbc",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.6d1d8634235374e3414cd047357c95dc.svg";
export { ForwardRef as ReactComponent };